<script>
    import { scrollY } from "../stores.js";

</script>

<main>
    <img
        style="transform: translateY({$scrollY / 2}px"
        class="heroImg"
        src="https://firebasestorage.googleapis.com/v0/b/pickapp-7bfc3.appspot.com/o/hero-bg.jpg?alt=media"
        alt=""
    />
    <div class="overlay" style="transform: translateY({$scrollY / 3}px">
        <div class="texts">
            <h1>למה לעמוד בתור - כשאפשר להזמין בפיקאפ?</h1>
            <h2>מהיום אפשר להזמין ולשלם בטלפון - לא רק במשלוחים</h2>
        </div>
    </div>
</main>

<style>
    main {
        width: 100%;
        min-height: 55vh;
        position: relative;
        padding-bottom: 50px;
        overflow: hidden;
        display: flex;
    }
    .heroImg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: bottom;
        z-index: 1;
        position: absolute;
    }
    .texts {
        width: 80%;
        margin: 0;
        padding: 35px 5vw 0 0px;
        color: white;
        direction: rtl;
        box-sizing: border-box;
        margin-left: auto;
        z-index: 1;
        font-family: "Varela round";
    }

    h1 {
        margin: 0;
        font-size: 62px;
    }

    h2 {
        font-size: 28px;
        margin-top: 40px;
    }

    .overlay {
        width: 100%;
        background: #000000e0;
        z-index: 2;
        margin-top: 80px;
        margin-bottom: 190px;
        padding-bottom: 30px;
    }

    @media (max-width: 620px) {
        .texts {
            width: 85%;
            padding: 40px 7vw 0 0px;
        }

        h1 {
            font-size: 48px;
        }

        h2 {
            font-size: 22px;
        }
    }

</style>
